export default function Hero() {
  return (
    <section
      id="hero"
      className="relative pt-[72px] bg-background-50 overflow-hidden"
    >
      <div className="w-full px-4 md:px-6 py-12 md:py-16 lg:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-[1200px] mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-5">
              <i className="ri-sparkling-2-line"></i>
              <span>高清免费 · 不缓冲 · 更新快</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-foreground-950 leading-tight">
              丫丫影院
              <span className="block text-2xl md:text-3xl lg:text-4xl text-foreground-700 mt-2">
                最新电影电视剧高清流畅在线观看
              </span>
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 mt-2 font-heading italic">
              全网最新影视资源，流畅不卡顿，全高清画质免费看
            </p>

            <p className="mt-6 text-sm md:text-base text-foreground-600 leading-relaxed max-w-[560px] mx-auto lg:mx-0">
              丫丫影院每日更新海量最新电影和电视剧资源，覆盖动作、喜剧、爱情、科幻、动漫等全类型。无需注册、无广告打扰，即点即播，高清画质搭配智能加速技术，确保观影全程不缓冲。无论是最新院线大片还是热门剧集，丫丫影院为您提供一站式的流畅观影体验，让好内容零等待。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mt-8">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center bg-accent-100 rounded-full">
                  <i className="ri-movie-line text-accent-600 text-sm"></i>
                </div>
                <div className="text-left">
                  <div className="text-lg font-bold text-foreground-900">20000+</div>
                  <div className="text-xs text-foreground-500">影视资源</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center bg-accent-100 rounded-full">
                  <i className="ri-timer-line text-accent-600 text-sm"></i>
                </div>
                <div className="text-left">
                  <div className="text-lg font-bold text-foreground-900">每日更新</div>
                  <div className="text-xs text-foreground-500">同步热播</div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center bg-accent-100 rounded-full">
                  <i className="ri-shield-check-line text-accent-600 text-sm"></i>
                </div>
                <div className="text-left">
                  <div className="text-lg font-bold text-foreground-900">稳定高速</div>
                  <div className="text-xs text-foreground-500">不缓冲不卡顿</div>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <a
                href="#index"
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-lg hover:bg-primary-600 transition-colors text-center whitespace-nowrap text-sm"
              >
                <i className="ri-play-circle-line mr-2"></i>
                开始观影
              </a>
              <a
                href="#ranking"
                className="w-full sm:w-auto px-8 py-3 border border-foreground-300 text-foreground-700 font-medium rounded-lg hover:bg-background-100 transition-colors text-center whitespace-nowrap text-sm"
              >
                <i className="ri-fire-line mr-2"></i>
                热门排行
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-[520px]">
            <div className="relative rounded-xl overflow-hidden aspect-[4/3] bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Artistic%20cinematic%20abstract%20composition%20with%20warm%20red%20and%20gold%20tones%2C%20floating%20film%20frames%20and%20soft%20bokeh%20lights%2C%20elegant%20minimalist%20movie%20theater%20aesthetic%2C%20modern%20streaming%20visual%20with%20geometric%20shapes%2C%20dark%20background%20with%20warm%20accents&width=1040&height=780&seq=hero-visual-01&orientation=landscape"
                alt="丫丫影院 - 最新电影电视剧高清流畅在线观看"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/40 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background-100/60 to-transparent pointer-events-none"></div>
    </section>
  );
}